// OWNER: AREA-TEMPLATES (templates/*, partials/*). Components go in src/features/templates.
import { createFileRoute } from '@tanstack/react-router'
import { PROPOSAL_ID } from '@/api/queries/proposals'
import { PartialCrumb } from '@/features/templates/bits'
import { PartialEditor } from '@/features/templates/partials/PartialEditor'

interface PartialSearch {
  /** A proposal (`prp_…`) to load into the editor for review. */
  proposal?: string
  /** Open the header's pending proposals popover (list badges link here). */
  proposals?: boolean
}

export const Route = createFileRoute('/partials/$partialId')({
  staticData: { crumb: PartialCrumb, fullBleed: true },
  validateSearch: (s: Record<string, unknown>): PartialSearch => ({
    proposal:
      typeof s.proposal === 'string' && PROPOSAL_ID.test(s.proposal) ? s.proposal : undefined,
    proposals:
      s.proposals === true || s.proposals === 'true' || s.proposals === 1 ? true : undefined,
  }),
  component: PartialEditorPage,
})

function PartialEditorPage() {
  const { partialId } = Route.useParams()
  const { proposal, proposals } = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <PartialEditor
      partialId={partialId}
      proposalId={proposal}
      onProposalClose={() =>
        void navigate({ search: (prev) => ({ ...prev, proposal: undefined }), replace: true })
      }
      proposalsOpen={!!proposals}
      onProposalsOpenChange={(open) =>
        void navigate({
          search: (prev) => ({ ...prev, proposals: open || undefined }),
          replace: true,
        })
      }
    />
  )
}
